import { useRef, useEffect } from "react";
const PlacesInput = (props) => {
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  const options = {
    fields: ["address_components", "geometry", "icon", "name", "formatted_address", "adr_address"],
  };
  useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );
    autoCompleteRef.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef.current.getPlace();
      console.log({ place });
      props.onSetValue(place)

    });
  }, []);

  return (
    <div>
      <input {...props} ref={inputRef} style={{ outline: 'none', width: '100%' }} />
    </div>
  );
};
export default PlacesInput;